// Sem isso, digitar só DDD+número (sem "55" na frente) salva um telefone sem DDI —
// mesma classe de bug já achada e corrigida no backend (normalizePhone.js do
// caio-tabet-backend): quebra o envio de WhatsApp mais pra frente, silenciosamente.
export const ensureCountryCode = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  return digits;
};
